var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03.8-Puzzle-Pieces",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.8.3-Puzzle-Pieces---Incorrect-Placement",
    transform: "translate(-392.000000, -264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(392.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#202020",
    strokeWidth: 4,
    fill: "#FFFFFF",
    cx: 120,
    cy: 120,
    r: 118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.999809,197.499958 C162.812207,197.499958 197.499624,162.812541 197.499624,120.000143 C197.499624,77.1877451 162.812207,42.5003278 119.999809,42.5003278 C77.1874113,42.5003278 42.499994,77.1877451 42.499994,120.000143 C42.499994,162.812541 77.1874113,197.499958 119.999809,197.499958 Z M94.3437425,157.99993 L82.0000219,145.625082 C80.5312144,144.156274 80.5312144,141.781402 82.0000219,140.312595 L102.499851,120.000143 L82.0000219,99.6565636 C80.5312144,98.1877561 80.5312144,95.8125786 82.0000219,94.3440763 L94.3748704,81.9689227 C95.8436779,80.5001152 98.2185502,80.5001152 99.6873577,81.9689227 L119.999809,102.500185 L140.343389,82.0003557 C141.812196,80.5315482 144.187374,80.5315482 145.655876,82.0003557 L158.03103,94.3752041 C159.499837,95.8440117 159.499837,98.2188839 158.03103,99.6876915 L137.499768,120.000143 L157.999597,140.343722 C159.468404,141.81253 159.468404,144.187707 157.999597,145.65621 L145.624748,157.99993 C144.155941,159.468738 141.781068,159.468738 140.312261,157.99993 L119.999809,137.500101 L99.6562298,157.99993 C98.1874223,159.468738 95.8122449,159.468738 94.3437425,157.99993 Z M119.999809,197.499958 C162.812207,197.499958 197.499624,162.812541 197.499624,120.000143 C197.499624,77.1877451 162.812207,42.5003278 119.999809,42.5003278 C77.1874113,42.5003278 42.499994,77.1877451 42.499994,120.000143 C42.499994,162.812541 77.1874113,197.499958 119.999809,197.499958 Z M94.3437425,157.99993 L82.0000219,145.625082 C80.5312144,144.156274 80.5312144,141.781402 82.0000219,140.312595 L102.499851,120.000143 L82.0000219,99.6565636 C80.5312144,98.1877561 80.5312144,95.8125786 82.0000219,94.3440763 L94.3748704,81.9689227 C95.8436779,80.5001152 98.2185502,80.5001152 99.6873577,81.9689227 L119.999809,102.500185 L140.343389,82.0003557 C141.812196,80.5315482 144.187374,80.5315482 145.655876,82.0003557 L158.03103,94.3752041 C159.499837,95.8440117 159.499837,98.2188839 158.03103,99.6876915 L137.499768,120.000143 L157.999597,140.343722 C159.468404,141.81253 159.468404,144.187707 157.999597,145.65621 L145.624748,157.99993 C144.155941,159.468738 141.781068,159.468738 140.312261,157.99993 L119.999809,137.500101 L99.6562298,157.99993 C98.1874223,159.468738 95.8122449,159.468738 94.3437425,157.99993 Z",
    id: "ttimes-circle",
    fill: "#D12348",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fdedfc9e6721f7d277d9e7ecce195c47.svg";
export { ForwardRef as ReactComponent };